import { CTAPIConfiguration } from './utils/configuration';
import { RequestHelper } from './utils/request';
import { PartRestInterface } from './interfaces/_part.rest';
import { Part } from '../models/interfaces/_part.model';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class PartRest implements PartRestInterface {

    private configuration: CTAPIConfiguration;
    private requestHelper: RequestHelper;

    constructor(configuration: CTAPIConfiguration) {
        this.configuration = configuration;
        this.requestHelper = new RequestHelper(configuration);
    }

    /**
     * Request for parts.
     */
    getParts(nCustID: number, nDivID, sEnvCode, sPartFull): Observable<Part[]> {
        if (!nCustID) {
            console.error('need a customer to fetch parts');
        }
        if (!nDivID) {
            console.error('need a division to fetch parts');
        }
        if (!sEnvCode) {
            console.error('need an environment to fetch parts');
        }return this.requestHelper.request(
            {
                data: {
                    nCustID,
                    nDivID,
                    sEnvCode,
                    sPartFull,
                    sorters: {
                        sPartName: 'ASC'
                    }
                }
            },
            this.configuration.part.get,
            this.configuration.httpClient
        ).pipe(
            map((response) => {
                return (!!response && !!response.result) ? response.result.parts : [];
            })
        );
    }

    /**
     * Request for handling guidelines.
     */
    getHandlingGuidelines(nDivID, aMdHandlingIDs, sEnvCode) {
        return this.requestHelper.request(
          {
            data: {
              nDivID,
              sEnvCode,
              aMdHandlingIDs,
            },
          },
          this.configuration.part.getHandlingGuidelines,
          this.configuration.httpClient
        ).pipe(
          map((response) => {
            return (!!response && !!response.result) ? response.result.handlingGuidelines : [];
          })
        );
    }
    /**
     * Request for handling guidelines.
     */
    getQuestionaire(nDivID, sEnvCode, nQuestionnaireIDs) {
        return this.requestHelper.request(
          {
            data: {
              nDivID,
              sEnvCode,
              nQuestionnaireIDs,
            },
          },
          this.configuration.part.getQuestionnaire,
          this.configuration.httpClient
        ).pipe(
          map((response) => {
            return (!!response && !!response.result) ? response.result.questionnaires : [];
          })
        );
    }

}
